import React, { useState } from "reactn";
import PropTypes from "prop-types";

// components
import FormGroup from "../../../../_common/form/form_group/FormGroup";
import InputGroup from "../../../../_common/form/input_group/InputGroup";
import Tabs from "../../../../_common/form/tabs/Tabs";
import Tab from "../../../../_common/form/tab/Tab";
import TabsConent from "../../../../_common/form/tabs_content/TabsContent";
import AddressNational from "../../address/delivery_address/national/addressNational";
import AddressInternational from "../../address/delivery_address/international/addressInternational";

import AddressLookUp from "../../../../_common/addressLookUp/addressLookUp";

// styled components
import PageText from "../../../../_common/pageText/PageText.styled";

const DeliveryAddress = props => {
  const {
    handleChange,
    handleKeyup,
    handleBlur,
    values,
    errors,
    formType,
    title
  } = props;
  const [currentIndex, setIndex] = useState(0);
  const setInternational = flag => {
    if (flag) {
      values.internationalSet = true;
      setIndex(1);
    } else {
      values.internationalSet = false;
      setIndex(0);
    }
  };
  return (
    <>
      {title && <PageText>{title}</PageText>}
      <FormGroup>
        {formType === "national" && (
          <AddressLookUp
            addressId="address"
            showText={false} innerTitle
            handleBlur={handleBlur}
            handleChange={handleChange}
            handleKeyup={handleKeyup}
            values={values}
            errors={errors}
            manualForm={<AddressNational
              handleChange={handleChange}
              handleKeyup={handleKeyup}
              values={values}
              errors={errors}
              handleBlur={handleBlur}
            />} />
        )}
        {formType === "international" && (
          <AddressInternational
            handleChange={handleChange}
            handleKeyup={handleKeyup}
            handleBlur={handleBlur}
            values={values}
            errors={errors}
          />
        )}
        {!formType && (
          <>
            <InputGroup>
              <Tabs defaultIndex={currentIndex}>
                <Tab
                  active={currentIndex === 0 ? true : false}
                  click={() => setInternational(false)}
                >
                  National
                </Tab>
                <Tab
                  active={currentIndex === 1 ? true : false}
                  click={() => setInternational(true)}
                >
                  International
                </Tab>
              </Tabs>
            </InputGroup>
            <TabsConent active={currentIndex === 0 ? true : false}>
              <AddressLookUp
                addressId="address"
                showText={false} innerTitle
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleKeyup={handleKeyup}
                values={values}
                errors={errors}
                manualForm={<AddressNational
                  handleChange={handleChange}
                  handleKeyup={handleKeyup}
                  values={values}
                  errors={errors}
                  handleBlur={handleBlur}
                />} />
            </TabsConent>
            <TabsConent active={currentIndex === 1 ? true : false}>
              <AddressInternational
                handleChange={handleChange}
                handleKeyup={handleKeyup}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
              />
            </TabsConent>
          </>
        )}
      </FormGroup>
    </>
  );
};

DeliveryAddress.propTypes = {
  handleChange: PropTypes.func,
  handleKeyup: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  formType: PropTypes.string,
  title: PropTypes.string
};

export default DeliveryAddress;
